import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Storefront from './pages/Storefront';
import ProductPage from './pages/ProductPage';
import AboutUs from './pages/AboutUs';
import Shop from './pages/Shop';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import OrderTracking from './pages/OrderTracking';
import OrderTrackingSearch from './pages/OrderTrackingSearch';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import SitePage from './pages/SitePage';
import { StoreProvider, useStore } from './context/StoreContext';
import CustomCursor from './components/storefront/CustomCursor';
import { WhatsAppButton } from './components/ui/whatsapp-button';
import { FloatingCart } from './components/storefront/FloatingCart';
import '@questlabs/react-sdk/dist/style.css';

function AppContent() {
  const location = useLocation();
  const { trackEvent } = useStore();
  const isAdminRoute = location.pathname.startsWith('/admin');

  // Track page views (excluding admin routes)
  useEffect(() => {
    if (!isAdminRoute && trackEvent) {
      trackEvent('page_view', { page_url: location.pathname });
    }
  }, [location.pathname, isAdminRoute, trackEvent]);

  return (
    <>
      <CustomCursor />
      {!isAdminRoute && <WhatsAppButton />}
      <FloatingCart />
      <Routes>
        <Route path="/" element={<Storefront />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/page/:slug" element={<SitePage />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/track" element={<OrderTrackingSearch />} />
        <Route path="/track/:id" element={<OrderTracking />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
    </>
  );
}

function App() {
  useEffect(() => {
    const hash = window.location.hash;
    const search = window.location.search;
    
    if (search.includes('merchantRID') && hash.includes('/payment/success')) {
      window.location.replace('/payment/success' + search);
      return;
    }

    if (hash && hash.startsWith('#/')) {
      const newPath = hash.substring(1);
      window.location.replace(newPath + search);
    }
  }, []);

  return (
    <StoreProvider>
      <Router>
        <AppContent />
      </Router>
    </StoreProvider>
  );
}

export default App;